import { NavBar as AntdMobileNavBar } from "antd-mobile";
import { BaseNavBarProps } from "./NavBar.types";
import "./NavBar.scss";

export const NavBar: React.FC<BaseNavBarProps> = ({
  children,
  variant = "primary",
  size = "xs",
  title,
  left,
  right,
  back,
  backIcon,
  backArrow = true,
  onBack,
  className = "",
  testId,
  ...props
}) => {
  const navBarClass = [
    "nav-bar",
    `nav-bar--${variant}`,
    `nav-bar--${size}`,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <AntdMobileNavBar
      className={navBarClass}
      left={left}
      right={right}
      back={back}
      backIcon={backIcon}
      backArrow={backArrow}
      onBack={onBack}
      data-testid={testId}
      {...props}
    >
      {title || children}
    </AntdMobileNavBar>
  );
};

export default NavBar;
